import barba from "@barba/core";
import { delay, paginationControls } from "../components/utils";
import { cluesInit } from "../components/clue";
import { bubbles } from "../components/bubbles";
import { setStoreQuestionValue, getStoreQuestionValue } from "../components/stores";

const trial_3_4 = () => {
    delay(500).then(() => {

    // --------------------------------------------------
    // question variables
    // --------------------------------------------------
    let questionIndex = 3;
    let questionPart = 3;

           // pagination
           paginationControls(questionIndex);

    // --------------------------------------------------
    // Functions
    // --------------------------------------------------
    
    cluesInit("sfx_interface.mp3", "spellbound");
    bubbles();
  
    // --------------------------------------------------
    // modify storage
    // --------------------------------------------------

    // get localStorage
    let storedValue = getStoreQuestionValue("assessment", "questions", questionIndex, questionPart);
    if(storedValue) { 
        gsap.utils.toArray('[name=radio_3_4]').forEach(element => {
            if(element.value == storedValue){ element.checked = true; }
        });
    }

    // set localStorage
    const setLocalStorage = () => {
        let selectedCheckbox = document.querySelector('[name=radio_3_4]:checked');
        if(selectedCheckbox !== null){
            setStoreQuestionValue("assessment", "questions", questionIndex, questionPart, selectedCheckbox.value);
        }
    }

    // --------------------------------------------------
    // slide navigation
    // --------------------------------------------------
    const saveAndContinue = (link) => { 
        setLocalStorage(); 
        barba.go(link); 
    };
    const next = document.querySelector(".js-next");
    const prev = document.querySelector(".js-prev");
    if(prev){
        prev.addEventListener("click", (e) => {
            e.preventDefault();
            saveAndContinue(e.target.href);
        });
    }
    if(next){
        next.addEventListener("click", (e) => {
            e.preventDefault();
            saveAndContinue(e.target.href);
        });
    }
    
});
};

export { trial_3_4 };
